'use client';

import { c as _c } from "react/compiler-runtime";
import cn from 'clsx';
import gsap from 'gsap';
import { useLenis } from 'lenis/react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Glyphs } from '~/components/button';
import { Link } from '~/components/link';
import { ThemeButton } from '~/components/theme-button';
import { useCartContext } from '~/integrations/shopify/cart/cart-context';
import { useCartModal } from '~/integrations/shopify/cart/modal';
import { useStore } from '~/libs/store';
import s from './mobile-menu.module.css';
const themes = [{
  theme: 'light'
}, {
  theme: 'simple'
}, {
  theme: 'dark'
}, {
  theme: 'red'
}];
export function MobileMenu(t0) {
  const $ = _c(55);
  const {
    className,
    navItems
  } = t0;
  const {
    isNavOpened,
    setIsNavOpened
  } = useStore(_temp);
  const {
    totalQuantity
  } = useCartContext();
  const {
    openCart
  } = useCartModal();
  const itemCount = totalQuantity();
  const [, setMounted] = useState(false);
  const navRef = useRef(null);
  const themesRef = useRef(null);
  const lenis = useLenis();
  const themeLineRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
      return () => setMounted(false);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== lenis || $[3] !== setIsNavOpened) {
    t3 = function handleNavToggle(open) {
      if (open) {
        lenis?.stop();
      } else {
        lenis?.start();
      }
      setIsNavOpened(open);
    };
    $[2] = lenis;
    $[3] = setIsNavOpened;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleNavToggle = t3;
  const animateNavElements = _temp2;
  const animateThemeButtons = _temp3;
  const animateOverlay = _temp4;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      gsap.fromTo(themeLineRef.current, {
        clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)"
      }, {
        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
        duration: 0.5,
        delay: 0.45,
        ease: "power2.inOut"
      });
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const animateThemeLine = t4;
  let t5;
  let t6;
  if ($[6] !== isNavOpened) {
    t5 = () => {
      if (!(navRef.current && themesRef.current)) {
        return;
      }
      const navLinks = navRef.current.querySelectorAll("a");
      const cartButton = document.querySelector(`.${s.cart}`);
      const themeButtons = themesRef.current.querySelectorAll("button");
      const overlay_0 = document.querySelector(`.${s.overlay}`);
      const navElements = [...navLinks];
      if (cartButton) {
        navElements.push(cartButton);
      }
      if (isNavOpened) {
        animateNavElements(navElements);
        animateThemeButtons(themeButtons);
        animateThemeLine();
      }
      animateOverlay(overlay_0, isNavOpened);
    };
    t6 = [isNavOpened, animateNavElements, animateThemeButtons, animateOverlay, animateThemeLine];
    $[6] = isNavOpened;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  let t7;
  if ($[9] !== className) {
    t7 = cn(className, "h-full");
    $[9] = className;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== handleNavToggle || $[12] !== isNavOpened) {
    t8 = () => {
      handleNavToggle(!isNavOpened);
    };
    $[11] = handleNavToggle;
    $[12] = isNavOpened;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t10;
  let t11;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span />;
    t10 = <span />;
    t11 = <span />;
    $[14] = t10;
    $[15] = t11;
    $[16] = t9;
  } else {
    t10 = $[14];
    t11 = $[15];
    t9 = $[16];
  }
  let t12;
  if ($[17] !== isNavOpened || $[18] !== t8) {
    t12 = <button type="button" className={s.hamburger} onClick={t8} data-open={isNavOpened}>{t9}{t10}{t11}</button>;
    $[17] = isNavOpened;
    $[18] = t8;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = cn(s.inner, "grid uppercase spt-8 spb-8");
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== handleNavToggle || $[22] !== navItems) {
    t14 = navItems?.sort(_temp5).map((t15, _idx) => {
      const {
        label,
        href
      } = t15;
      return <Link key={label} onClick={() => {
        handleNavToggle(false);
      }} href={href} className={cn("link bg-contrast p-safe", s.navItem)}>{label}</Link>;
    });
    $[21] = handleNavToggle;
    $[22] = navItems;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t14) {
    t15 = <nav ref={navRef} className={t13}>{t14}</nav>;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== handleNavToggle || $[27] !== itemCount || $[28] !== openCart) {
    t16 = itemCount > 0 && <button type="button" className={cn(s.cart, "link bg-secondary text-primary p-safe uppercase w-full smb-8 flex  items-center")} onClick={() => {
      openCart();
      handleNavToggle(false);
    }}><Glyphs className={cn(s.glyphs, "flex items-center")} /><span className="sml-8 w-full">Cart<sup>[{itemCount.toString().padStart(2, "0")}]</sup></span><Glyphs className={cn(s.glyphs, "flex items-center")} isReversed={true} /></button>;
    $[26] = handleNavToggle;
    $[27] = itemCount;
    $[28] = openCart;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = cn(s["theme-container"], "grid grid-cols-4 sgap-x-4");
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  let t19;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className={s["theme-line"]} ref={themeLineRef} />;
    t19 = themes.map(_temp6);
    $[31] = t18;
    $[32] = t19;
  } else {
    t18 = $[31];
    t19 = $[32];
  }
  let t20;
  if ($[33] !== isNavOpened) {
    t20 = <div ref={themesRef} className={t17} data-open={isNavOpened}>{t18}{t19}</div>;
    $[33] = isNavOpened;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t15 || $[36] !== t16 || $[37] !== t20) {
    t21 = <div className={s.nav}>{t15}{t16}{t20}</div>;
    $[35] = t15;
    $[36] = t16;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== isNavOpened || $[40] !== t21) {
    t22 = <div className={s.menu} data-open={isNavOpened}>{t21}</div>;
    $[39] = isNavOpened;
    $[40] = t21;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  const t23 = !isNavOpened && "pointer-events-none";
  let t24;
  if ($[42] !== t23) {
    t24 = cn(s.overlay, t23);
    $[42] = t23;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== handleNavToggle || $[45] !== isNavOpened) {
    t25 = () => {
      handleNavToggle(!isNavOpened);
    };
    $[44] = handleNavToggle;
    $[45] = isNavOpened;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== t24 || $[48] !== t25) {
    t26 = <button type="button" className={t24} onClick={t25} />;
    $[47] = t24;
    $[48] = t25;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== t12 || $[51] !== t22 || $[52] !== t26 || $[53] !== t7) {
    t27 = <div className={t7}>{t12}{t22}{t26}</div>;
    $[50] = t12;
    $[51] = t22;
    $[52] = t26;
    $[53] = t7;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  return t27;
}
function _temp6(t0) {
  const {
    theme
  } = t0;
  return <ThemeButton key={theme} className="sh-28 spy-9 spx-8 bg-contrast" theme={theme} />;
}
function _temp5(a, b) {
  return a.order - b.order;
}
function _temp4(overlay, isOpen) {
  gsap.to(overlay, {
    opacity: isOpen ? 0.7 : 0,
    ease: "power2.inOut"
  });
}
function _temp3(buttons) {
  gsap.fromTo(buttons, {
    opacity: 0,
    y: 60
  }, {
    opacity: 1,
    y: 0,
    duration: 0.5,
    delay: 0.25,
    stagger: {
      amount: 0.3,
      from: "start"
    },
    ease: "power2.out"
  });
}
function _temp2(elements) {
  gsap.fromTo(elements, {
    opacity: 0,
    y: 60
  }, {
    opacity: 1,
    y: 0,
    duration: 0.5,
    stagger: {
      amount: 0.3,
      from: "start"
    },
    ease: "power2.out"
  });
}
function _temp(state) {
  return state;
}